import AdminLoadable from 'components/core/AdminLoadable';

export default AdminLoadable({
  loader: () => import('./Connected'),
  name: 'EditableHeaderCountdown',
});
